import { render } from "./FillTheBlanks.vue?vue&type=template&id=a0fb0176"
import script from "./FillTheBlanks.vue?vue&type=script&lang=js"
export * from "./FillTheBlanks.vue?vue&type=script&lang=js"

import exportComponent from "/Users/georgwidschwendter/Documents/GitHub/learn/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__